import React from 'react';
import { Checkbox } from '@naf-simba/elements-checkbox';
import { Controller } from 'react-hook-form';
import { TextVariant } from '@naf/text';
import xor from 'lodash/xor';
import S from './Styles';
import { AddonProductFormFields } from './AddonProductFormFields';
import { AddonProductVariantProps } from './AddonProductField.types';

export const ActivationProductField = ({
  product,
  selectedMembers,
  storedMembers,
  control,
  errors,
  watch,
  setValue,
}: AddonProductVariantProps) => (
  <S.FieldWrapper $error={!!errors[product.productNumber]}>
    <Controller
      name={`${product.productNumber}.members`}
      control={control}
      defaultValue={storedMembers || []}
      render={({ field: { value, onChange } }) => (
        <S.LabelWrapper>
          {product.isRequiredAddOn ? (
            <S.StyledLabel variant={TextVariant.ArticleTextSubHeader}>{product.productName}</S.StyledLabel>
          ) : (
            <Checkbox
              label={product.productName}
              name={product.productName}
              checked={value.includes('0')}
              onChange={() => onChange(xor(value as string[], ['0']))}
            />
          )}
          {product.shortDescription ? <S.StyledTooltip title={product.shortDescription} /> : null}
        </S.LabelWrapper>
      )}
    />
    {!!selectedMembers?.length && product.fieldComponents.length > 0 && (
      <S.FormFieldsWrapper>
        <AddonProductFormFields product={product} control={control} errors={errors} watch={watch} setValue={setValue} />
      </S.FormFieldsWrapper>
    )}
  </S.FieldWrapper>
);
